import { useState, useEffect } from 'react';
import { calculateDaysBetween, calculateTimeUnits } from './DateUtils';

/**
 * Custom hook for calculating days together and time breakdown
 */
export const useDateCalculation = (startDate) => {
  const [daysTogether, setDaysTogether] = useState(0);
  const [timeUnits, setTimeUnits] = useState({ years: 0, months: 0, days: 0 });

  useEffect(() => {
    if (!startDate) return;

    const calculateTime = () => {
      setDaysTogether(calculateDaysBetween(startDate));
      setTimeUnits(calculateTimeUnits(startDate));
    };

    // Calculate immediately
    calculateTime();

    // Update every minute
    const interval = setInterval(calculateTime, 1000 * 60);

    return () => clearInterval(interval);
  }, [startDate]);

  return { daysTogether, timeUnits };
};